<template>
  <div class="validation-container">
    <snackbar
      v-if="snackbar.show"
      :error="snackbar.error"
      :success="snackbar.success"
      :message="snackbar.message"
      @close="resetSnackbar"
    />
    <div class="validation-container__logo">
      <img src="@/assets/partners/playhub.png" alt="PlayHub Logo" />
    </div>
    <div class="validation-container__header">
      <h1>{{ $t('partnerships.form.playhub.validation.headerTitle') }}</h1>
      <p>{{ $t('partnerships.form.playhub.validation.headerDescription') }}</p>
    </div>
    <form class="validation-container__form">
      <div class="validation-container__form__body">
        <div class="combobox-container">
          <input
            class="combobox-input"
            :placeholder="$t('partnerships.form.playhub.validation.internetProvider')"
            id="isp"
            v-model="ispName"
            @input="listIsp"
            type="text"
          />
          <ul v-if="isps && isps.length > 0" class="isp-list">
            <li v-for="isp in isps" :key="isp.id" @click="selectIsp(isp)" class="isp-item">{{ isp }}</li>
          </ul>
        </div>
        <div class="'validation-container__form__body__input-group'">
          <pk-input
            v-model="login"
            :placeholder="$t('partnerships.form.playhub.validation.inputUser')"
            type="text"
          />
        </div>
        <div class="validation-container__form__body__input-group">
          <pk-input
            :placeholder="$t('partnerships.form.playhub.validation.inputPassword')"
            v-model="password"
            type="password"
            :errorText="$t('partnerships.form.errors.inputPassword')"
          />
        </div>
        <div class="validation-container__form__body__button">
          <btn
            class="validation-container__form__body__button__submit-btn"
            @click="handleClick"
          >Validar</btn>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import integrationACLAPI from '@/api/integration-acl'
import NewResponseError from '@/api/http/NewResponseError'
import { mapActions } from 'vuex'

const errorText = {
  notFound: 'Ops. Não encontramos uma conta PlayHub para o seu plano.<br />Por favor, entre em contato com a sua operadora para verificar a ativação da sua conta.',
  generic: 'Ops! Algo não funcionou como esperávamos enquanto validávamos sua conta na PlayHub.<br />Por favor, entre em contato com a sua operadora.'
}

export default {
  name: 'partner-playhub',
  data() {
    return {
      form: {
        processing: false
      },
      resultadoValidacao: null,
      snackbar: {
        show: false,
        message: '',
        error: true,
        success: false
      },
      ispName: '',
      isps: [],
      login: '',
      password: ''
    }
  },
  methods: {
    async listIsp() {
      try {
        this.isps = await integrationACLAPI.searchIsp(this.ispName)
      } catch (error) {
        console.error(error)
      }
    },
    selectIsp(isp) {
      this.ispName = isp
      this.isps = []
    },
    async handleClick() {
      const ispName = this.ispName
      const login = this.login
      const password = this.password
      try {
        const { resultValidation, resultCheck } = await integrationACLAPI.unlockAccount(ispName, login, password)
        if (resultValidation.ExternalId === resultCheck.ExternalId) {
          this.$store.commit('setEmail', resultValidation.Email)
          this.$store.commit('setExternalId', resultCheck.ExternalId)
          this.$store.commit('setPlanId', resultCheck.PlanId)
          this.$store.commit('setLogin', login)
          this.$router.push('/playhub/account')
        }
      } catch (error) {
        let errorBody = ''
        let errorCode = ''
        if (error instanceof NewResponseError) {
          errorBody = error.body.Mensagem
          errorCode = error.body.Codigo
        } else {
          errorBody = error.message
        }
        this.snackbar = {
          show: true,
          message: error.body && errorBody ? `${errorBody} (Error code: ${errorCode})` : errorText.generic,
          success: false,
          error: true
        }
      }
    },
    ...mapActions(['setEmail']),
    resetSnackbar() {
      this.snackbar = {
        show: false,
        message: ``,
        success: false,
        error: false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.validation-container {
  position: relative;
  flex-grow: 1;
  overflow: visible;
  padding: 0 4rem;
  &__logo {
    display: flex;
    justify-content: center;
    min-width: 100%;
    margin-top: 22px;
    margin-bottom: 4rem;

    img {
      max-width: 161px;
      max-height: 163px;
    }

    @media screen and (min-width: 641px) {
      img {
        max-width: 201px;
        max-height: 203px;
      }
    }
  }
  &__header {
    min-width: 100%;
    margin-bottom: 2rem;
    h1 {
      font-family: Nunito;
      font-style: normal;
      font-weight: 900;
      font-size: 26px;
      line-height: 32px;
      color: #443D4B;
    }
    p {
      font-family: Nunito;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #454545;
    }

    @media screen and (min-width: 641px) {
      h1 {
        max-width: 95%;
      }
      p {
        max-width: 95%;
      }
    }
  }
  &__form {
    width: 100%;
    max-width: 480px;
    margin-bottom: 6rem;
    &__body {
      min-width: 100%;
      .combobox-container {
          position: relative;
          margin-bottom: 1rem;
          .combobox-input {
            width: 100%;
            padding: 12px;
            font-size: 16px;
            border: 1px solid #ddd;
            border-radius: 4px;
            outline: none;
            &:focus {
              border-color:purple;
              box-shadow: 0 0 0 3px rgba(108, 99, 255, 0.2);
            }
          }
          .isp-list {
            position: absolute;
            top: 100%;
            left: 0;
            right: 0;
            background-color: #fff;
            border: 1px solid #ddd;
            border-top: none;
            border-radius: 0 0 4px 4px;
            max-height: 200px;
            overflow-y: auto;
            z-index: 10;
            padding: 0;
            margin: 0;
            list-style: none;
            li {
              padding: 12px;
              cursor: pointer;
              &:hover {
                background-color: #f5f5f5;
              }
            }
          }
        }
      &__input-group {
        margin-bottom: 1rem;
      }
      &__button {
        display: flex;
        &__submit-btn {
          width: 100%;
          flex: 1;
          margin-top: 2rem;
        }
      }
      .hint-error {
        color: $error-color;
      }
    }
  }
}
</style>
